import * as React from 'react';

import { PrimaryActionSlot } from '../../locations';

export default function PrimaryActionLocation() {
	return <PrimaryActionSlot />;
}
